import React, { useEffect, useState } from 'react';
import { UserInput, userInputDefault } from './interface/interface';
import { useValidation } from '../../../hooks/useValidation';
import { Loader } from '../../shared/Loader/Loader';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { authenticateUser } from './utils/authenticateUser';
import { TextCustom } from '../../ui/TextCustom';
import { SpacingCustom } from '../../layout/Spacing/SpacingCustom';
import IconComponent from '../../shared/IconComponents/IconComponent';
import { PanelLayout } from '../../layout/Panel/Panel';
import { Spacing } from '../../layout/Spacing/Spacing';
import { useSendWebsocketMessage } from '../WebSocket/hooks/useSendWebsocketMessage';
import { useWebSocket } from '../WebSocket/hooks/useWebSocket';
import { WEBSOCKET_PARAMETERS } from '../../../constants/constants';
import { rootState } from '../../../redux/store';
import { IUserSettingsAddUserBody } from '../../../interface/interfaces';
import { saveUserToDb } from './utils/saveUserToDb';
import { userLoginSchema } from '../../../redux/validation/schemas';

export const LoginFormInPro = () => {

    const { socketRef } = useWebSocket('Login config');
    const { sendWebsocketMessage } = useSendWebsocketMessage(socketRef);
    
    const dispatch = useAppDispatch();
    const { register, handleSubmit, errors } = useValidation<UserInput>(userLoginSchema, userInputDefault);
    const [loading, setLoading] = useState<boolean>(false);
    const [saveUserToDbLoading, setSaveUserToDbLoading] = useState<boolean>(false);
    const navigate = useNavigate();
    const location = useLocation();

    const {userAndTokenData} = useAppSelector((state:rootState)=>state.loginUserAndTokenData);

    const onSubmitHandler = async (values: UserInput) => {
        // auth user (checking username and password)
        authenticateUser(setLoading, values, dispatch, navigate, location);
        // save hostname and username to redux and local storage via websocket
        sendWebsocketMessage(JSON.stringify({parameter: WEBSOCKET_PARAMETERS.USER_SETTINGS_HOSTNAME}))
    };

    useEffect(()=>{
        // save user to db
        const userDataForDB: IUserSettingsAddUserBody = {
            id: userAndTokenData?.user.uniqueId || '',
            username: userAndTokenData?.user.username || '',
            language_id: 1
        }

        console.log('userDataForDB', userDataForDB)
        if(userAndTokenData){
            saveUserToDb(setSaveUserToDbLoading, userDataForDB, dispatch)
        }
    }, [userAndTokenData])

    return (
        <div className="login-form animation">
            <PanelLayout borderIntensity={0} radius="l" bigShadow>
                <Spacing marginSpacing="none" paddingSpacing="xxl">
                    <form className="login-form__form" onSubmit={handleSubmit(onSubmitHandler)}>
                        <div className="login-form__form--logo">
                            <SpacingCustom paddingLeft={1} paddingTop={1} paddingBottom={1}>
                                <IconComponent size={8} iconName={'Login_logo_white'} />
                            </SpacingCustom>
                            <TextCustom color="white" size={3.2} weight={800}>
                                InVersum
                            </TextCustom>
                        </div>
                        <div className="login-form__form--input-box">
                            <label htmlFor="username">User</label>
                            <input type="text" {...register('Username')} placeholder="LDAP-Username" id="username" required />
                            <div className="error-group">{errors.Username ? <p>{errors.Username?.message}</p> : <p></p>}</div>
                        </div>

                        <div className="login-form__form--input-box">
                            <label htmlFor="password">Password</label>
                            <input type="password" {...register('Password')} placeholder="Enter your password" id="password" required />
                            <div className="error-group">{errors.Password ? <p>{errors.Password?.message}</p> : <p></p>}</div>
                            <div className="forgot-password">
                                <a href="#">Forgot Password?</a>
                            </div>
                        </div>
                        <button
                            className={`login-form__submit ${loading ? 'login-form__submit--disabled' : 'login-form__submit--enabled'}`}
                            type="submit"
                            disabled={loading ? true : false}
                            value={'Log in'}
                        >
                            {loading ? <Loader /> : <p>LOG IN</p>}
                        </button>
                    </form>
                </Spacing>
            </PanelLayout>
        </div>
    );
};
